<template>
  <div id="bidother" class="zl-form-group">
    <div class="zl-form-group-header">
      <div class="zl-form-group-title">
        <i class="title-decorate iconfont icon-decorate" />
        其他设置
      </div>
    </div>
    <div class="zl-form-group-form">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="报价邀请" prop="quoteRequirementsSign" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.quoteRequirementsSign">
              <el-radio label="Y">允许部分报价</el-radio>
              <el-radio label="N">不允许部分报价</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ quoteRequirementsSign }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="上传附件设置" prop="uploadFileSign" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.uploadFileSign">
              <el-radio label="1">允许上传但互相不允许查看</el-radio>
              <el-radio label="2">允许上传并互相允许查看</el-radio>
              <el-radio label="3">不允许上传</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ quoteRequirementsSign }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标书要求" prop="mailBiddingSign" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.mailBiddingSign">
              <el-radio label="Y">需要邮寄标书</el-radio>
              <el-radio label="N">不需要邮寄标书</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ mailBiddingSign }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.mailBiddingSign==='Y'" :gutter="24">
        <el-col :span="8">
          <el-form-item label="收件人" prop="mailReceiver" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.mailReceiver" />
            <span v-else class="mybidding-display"> {{ form.mailReceiver }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="mailPhone" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.mailPhone" />
            <span v-else class="mybidding-display"> {{ form.mailPhone }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮寄截止日期" prop="mailDate" label-width="100px">
            <el-date-picker
              v-if="!isDisplay"
              v-model="form.mailDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
            <span v-else class="mybidding-display"> {{ form.mailDate }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.mailBiddingSign==='Y'" :gutter="24">
        <el-col :span="8">
          <el-form-item label="邮寄地址" prop="mailAddress" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.mailAddress" />
            <span v-else class="mybidding-display"> {{ form.mailAddress }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="资质文件要求" prop="qualificationSign" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.qualificationSign">
              <el-radio label="N">不需要资质文件</el-radio>
              <el-radio label="Y">需要资质文件</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ qualificationSign }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.qualificationSign==='Y'" :gutter="24">
        <el-col :span="24">
          <el-form-item label="要求资质名称" prop="requiredQualificationName" label-width="100px">
            <el-input
              v-model="form.requiredQualificationName"
              style="width: 400px"
              placeholder=""
              maxlength="300"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDisplay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    quoteRequirementsSign() {
      let des = ''
      switch (this.form.quoteRequirementsSign) {
        case 'Y':
          des = '允许部分报价'
          break

        case 'N':
          des = '不允许部分报价'
          break
      }
      return des
    },
    uploadFileSign() {
      let des = ''
      switch (this.form.uploadFileSign) {
        case '1':
          des = '允许上传但互相不允许查看'
          break
        case '2':
          des = '允许上传并互相允许查看'
          break
        case '3':
          des = '允许上传并互相允许查看'
          break
      }
      return des
    },
    mailBiddingSign() {
      let des = ''
      switch (this.form.mailBiddingSign) {
        case 'Y':
          des = '需要邮寄标书'
          break
        case 'N':
          des = '不需要邮寄标书'
          break
      }
      return des
    },
    qualificationSign() {
      let des = ''
      switch (this.form.qualificationSign) {
        case 'Y':
          des = '需要资质文件'
          break
        case 'N':
          des = '不需要资质文件'
          break
      }
      return des
    }
  }

}
</script>
<style lang="scss" scoped>
@import './common.scss';

</style>
